import { render, staticRenderFns } from "./EditModal.vue?vue&type=template&id=bc4e84b2"
import script from "./EditModal.vue?vue&type=script&lang=js"
export * from "./EditModal.vue?vue&type=script&lang=js"
import style0 from "./EditModal.vue?vue&type=style&index=0&id=bc4e84b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports